import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'product-image',
  template: `<ng-content></ng-content>`,
})
export class ProductImageComponent {}
